import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  icon: {
    color: '#CCCCCC'
  },
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 500,
    padding: theme.spacing(6)
  },
  badge: {
    minWidth: theme.spacing(2.2),
    height: theme.spacing(2.2),
    width: theme.spacing(2.2)
  },
  cell: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '14px',
    width: 200,
    padding: theme.spacing(0.3, 2)
  },
  inactive: {
    transition: 'all 300ms ease 0s',
    opacity: 0.2,
    pointerEvents: 'none'
  },
  redWrapper: {
    backgroundColor: '#f06565',
    borderRadius: '4px',
    padding: '4px',
    display: 'flex',
    justifyContent: 'center'
  },
  greenWrapper: {
    backgroundColor: '#73dea2',
    borderRadius: '4px',
    padding: '4px',
    display: 'flex',
    justifyContent: 'center',
    minHeight: 28
  },
  alignRight: {
    float: 'right',
    padding: '12px'
  },
  bgRed: {
    backgroundColor: '#f06565'
  },
  bgGreen: {
    backgroundColor: '#73dea2'
  },
  spaceBetween: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  iconBlack: {
    color: '#000'
  },
  ctaButton: {
    borderRadius: 60,
    height: '100%',
    width: theme.spacing(13),
    color: theme.palette.primary.main,
    background: theme.palette.common.white,
    fontWeight: 'bold',
    boxShadow: 'none',
    border: '1px solid #5381EF',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.common.white
    },
    '&:hover .MuiIcon-root': {
      color: 'white !important'
    }
  },
  iconColor: {
    color: '#5381EF !important'
  },
  tableContainer: {
    padding: theme.spacing(0, 3)
  },
  toolbarWrapper: {
    '& .MuiToolbar-gutters': {
      paddingLeft: 0
    },
    '& .MuiIconButton-root': {
      padding: '30px 0'
    }
  },
  paddingY: {
    padding: '0 30px'
  }
}));

export default useStyles;
